const HOME_URL = 'https://sideloop.golf';

export default function BrandLogo({ href = HOME_URL, className = '', showTagline = true }) {
  return (
    <div className={`sl-brand ${className}`.trim()}>
      <a href={href} className="sl-logo">
        <span className="sl-dollar-s">S</span>ide Loop
      </a>
      {showTagline && (
        <span className="sl-tagline">
          Every round has a <em className="sl-accent">story.</em>
        </span>
      )}
    </div>
  );
}
